module.exports = __webpack_public_path__ + "static/media/currency.ff80f615.svg";